import type { NavItem, SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Fit Design',
    description: 'Fit Design is an award-winning studio in London and Gdańsk. We plan, design and build Webflow websites for growing businesses, from first workshop to launch.',
    placeholder: '',
    url: getOrigin(),
    ogImage: 'https://fitdesign.cdn.modulify.website/work/stormborn/hero.webp'
}

export const navItems: NavItem[] = [
    { label: 'Work', href: '/work' },
    { label: 'Services', href: '/services' },
    { label: 'Studio', href: '/studio' },
    { label: 'Contact', href: '/contact' }
]

export const contact = {
    email: 'contact@fitdesignldn.com',
    phone: '+44 7726 925021',
    phoneHref: 'tel:+447726925021',
    calendly: 'https://calendly.com/fitdesignlondon/15min',
    clutch: 'https://clutch.co/go-to-review/b0af69b3-abaf-40d2-9b43-ababc7102a75/431425',
    studios: [
        { city: 'London', country: 'United Kingdom', zone: 'Europe/London' },
        { city: 'Gdańsk', country: 'Poland', zone: 'Europe/Warsaw' }
    ],
    socials: [
        { label: 'LinkedIn', href: 'https://uk.linkedin.com/company/fit-design-london' },
        { label: 'Facebook', href: 'https://www.facebook.com/fitdesignldn' },
        { label: 'X', href: 'https://x.com/Fitdesignldn' }
    ]
} as const

export const footerTagline = 'Website strategy, design and Webflow development for growing businesses, from London and Gdańsk.'
